import React from 'react'
import { TextDisabled } from './style'

export default function LockedMarker () {
  return <TextDisabled>LOCKED</TextDisabled>
}
